import React from 'react';
import './App.css';
import MainComponent from './components/mainComponent';
import { Routes, Route } from 'react-router-dom';
import { ProductType } from './constants/types';
import Marktplaats from './components/marktplaatsComponent';

const App: React.FunctionComponent = () => {
  return (
    <div>
      <Main />
    </div>
  );
};

const Main = () => (
  <Routes>
    <Route path="*" element={<MainComponent firstComponent={ProductType.All} />} />
    <Route path="/" element={<MainComponent firstComponent={ProductType.All} />}></Route>
    <Route path="/Algemene Voorwaarden" element={<MainComponent firstComponent={ProductType.Products} showText={"AlgemeneVoorwaarden"} />}></Route>
    <Route path="/Privacybeleid" element={<MainComponent firstComponent={ProductType.Products} showText={"PrivacyBeleid"} />}></Route>
    <Route path="/Retourbeleid" element={<MainComponent firstComponent={ProductType.Products} showText={"Retourbeleid"} />}></Route>
    <Route path="/Over Ons" element={<MainComponent firstComponent={ProductType.Products} showText={"SiteText"} />}></Route>
    <Route path="/Producten" element={<MainComponent firstComponent={ProductType.Products} />}></Route>
    <Route path="/Promo" element={<MainComponent firstComponent={ProductType.Promo} />}></Route>
    <Route path="/Promo2" element={<MainComponent firstComponent={ProductType.Promo2} />}></Route>
    <Route path="/Marktplaats" element={<Marktplaats />}></Route>
    <Route path="/set/*" element={<MainComponent firstComponent={ProductType.Products} />}></Route>
    <Route path="/product/*" element={<MainComponent firstComponent={ProductType.Single} />}></Route>
  </Routes>
);

export default App;
